import * as React from "react";

import PropTypes from "prop-types";
import { Button, FormControl, InputGroup } from "react-bootstrap";
import * as _ from "lodash";
import ButtonIcon from "../../../general/ButtonIcon";

type Props = {
    q: string;
    onChange: (x0: string) => void;
};

type State = {
    value: string;
};

export class SearchInputFilterPanel extends React.Component<Props, State> {
    static contextTypes = {
        intl: PropTypes.object.isRequired
    };

    constructor(props: Props) {
        super(props);
        this.state = {
            value: props.q
        };
    }

    onChangeDebounced = _.debounce(() => this.props.onChange(this.state.value), 500, {
        leading: false,
        trailing: true
    });

    componentWillReceiveProps(newProps: Props) {
        // if the query changed, reset the value
        if (newProps.q !== this.props.q) {
            this.setState({
                value: newProps.q
            });
        }
    }

    handleOnChangeDesktop = (event: React.SyntheticEvent<any>) => {
        this.setState(
            {
                value: event.currentTarget.value || "*"
            },
            () => this.onChangeDebounced()
        );
    };

    handleOnChangeMobile = (event: React.SyntheticEvent<any>) => {
        this.setState({
            value: event.currentTarget.value || "*"
        });
    };

    render() {
        // this is a workaround, because the initial query is '*' and we dont want to show that
        const displayValue = this.state.value === "*" ? "" : this.state.value;

        return (
            <form
                onSubmit={(event) => {
                    event.preventDefault();
                    this.props.onChange(this.state.value);
                }}>
                <InputGroup className="mfcss_input-group-inset search-filter">
                    <FormControl
                        className="hidden-md hidden-xs hidden-sm"
                        type="text"
                        placeholder={this.context.intl.formatMessage({ id: "EX_FILTER_PANEL_SEARCH_PLACEHOLDER" })}
                        onChange={this.handleOnChangeDesktop}
                        value={displayValue}
                    />
                    <FormControl
                        className="hidden-lg hidden-xl"
                        type="text"
                        placeholder={this.context.intl.formatMessage({ id: "EX_FILTER_PANEL_SEARCH_PLACEHOLDER" })}
                        onChange={this.handleOnChangeMobile}
                        value={displayValue}
                    />
                    <InputGroup.Button>
                        <Button
                            bsStyle="link"
                            className="btn-square"
                            type="submit"
                            aria-label={this.context.intl.formatMessage({ id: "SD_SEARCH_BUTTON_ARIA_LABEL" })}>
                            <ButtonIcon symbol="magnify" />
                        </Button>
                    </InputGroup.Button>
                </InputGroup>
            </form>
        );
    }
}
